import TransferRequestType from "../../../types/TransferRequestType";
import * as Mui from "@mui/material";
import FormInput from "../../common/FormInput";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import { Parser } from "../../../utils";
import { useContext } from "react";
import { TransferContext } from "../../transferReason/TransferContext";
import EnumChangeName from "../../common/EnumChangeName";

interface Props {
  transferRequest?: TransferRequestType;
  creationDate?: string;
}
export const TransferRequestDetails = (props: Props) => {
  const t = useOperationTranslation();
  const { reason } = useContext(TransferContext);

  const { locationType } = EnumChangeName();

  let status = (params: string | undefined) => {
    if (params === undefined) return "";
    switch (params) {
      case "REJECTED":
        return t("transferReason.autocomplete.rejected");

      case "APPROVED":
        return t("transferReason.autocomplete.approved");

      case "TO_BE_APPROVED":
        return t("transferReason.autocomplete.toBeApproved");

      case "CREATED":
        return t("transferReason.autocomplete.created");

      case "APPROVED_WITH_DDT":
        return t("transferReason.autocomplete.approvedWithDdt");
      case "TRANSFER_COMPLETED":
        return t("transferReason.autocomplete.transferCompleted");
      case "DUPLICATE_CANCELLED_BY_SYSTEM":
        return t("transferReason.autocomplete.duplicateCancelledBySystem");
      default:
        return "";
    }
  };

  const reasonValue = reason.find(
    (el) => el.value == props.transferRequest?.reasonCode
  );
    
  const startLocation = `${props.transferRequest?.startStationDescription} (${locationType(props.transferRequest?.startStationType || "")})`;

  const expectedEndLocation = `${props.transferRequest?.expectedEndStationDescription} (${locationType(props.transferRequest?.expectedEndStationType || "")})`; 

  const endLocation = `${props.transferRequest?.endStationDescription} (${locationType(props.transferRequest?.endStationType || "")})`;

  return (
    <Mui.Card>
      <Mui.CardContent>
        <Mui.Grid
          container
          columns={12}
          alignItems="center"
          spacing={2.5}
          rowGap={4}
        >
          {/* -----------------------------------------------------1 row --------------------------------------------------------------*/}

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="number"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.number"
              )}
              value={props.transferRequest?.number || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="ddtNumber"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.ddtNumber"
              )}
              value={props.transferRequest?.deliveryNoteNumber || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="externalNumber"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.externalNumber"
              )}
              value={props.transferRequest?.externalNumber || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="requestDate"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.requestDate"
              )}
              value={props.transferRequest?.requestDate || ""}
              type="date"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="status"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.status"
              )}
              value={status(props.transferRequest?.status)}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="startStationDescription"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.startStationDescription"
              )}
              value={startLocation || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="startDate"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.startDate"
              )}
              value={
                props.transferRequest?.startDate
                // props.transferRequest?.externalNumber
                //   ? props.transferRequest?.startDate 
                //   : props.creationDate
              }
              type="date"
              disabled
              fullWidth
            />
          </Mui.Grid>

          {/* -----------------------------------------------------2 row --------------------------------------------------------------*/}

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="expectedEndStationDescription"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.expectedEndStationDescription"
              )}
              value={expectedEndLocation || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="expectedEndDate"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.expectedEndDate"
              )}
              value={props.transferRequest?.expectedEndDate || ""}
              type="date"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="endStationDescription"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.endStationDescription"
              )}
              value={endLocation || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="endDate"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.endDate"
              )}
              value={props.transferRequest?.endDate || ""}
              type="date"
              disabled
              fullWidth
            />
          </Mui.Grid>

          {/* -----------------------------------------------------3 row --------------------------------------------------------------*/}

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="loadIndex"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.loadIndex"
              )}
              value={props.transferRequest?.loadIndex || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="routeKm"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.routeKm"
              )}
              value={
                props.transferRequest?.routeKm !== undefined
                  ? `${props.transferRequest?.routeKm} KM`
                  : ""
              }
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>
          {/* -----------------------------------------------------4 row --------------------------------------------------------------*/}

          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="reasonCode"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.reasonCode"
              )}
              value={reasonValue?.label || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>
          <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
            <FormInput
              name="operatorCode"
              label={t(
                "deliveryNote.deliveryDetails.tab.transferRequest.operatorCode"
              )}
              value={props.transferRequest?.operatorCode || ""}
              type="text"
              disabled
              fullWidth
            />
          </Mui.Grid>
        </Mui.Grid>
      </Mui.CardContent>
    </Mui.Card>
  );
};
